import React from 'react';
import { connect } from 'react-redux';
import 'react-resizable/css/styles.css';

import PrintContent from './Content';

import { IRootState } from '../../modules/stores';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps extends IConnectProps {
  isCurrentRecord: boolean;
}

class Print extends React.PureComponent<IProps> {
  public render() {
    const { currentRecordId, isCurrentRecord, recordIds, spaceById, spaceAllIds } = this.props;

    return (
      <PrintContent
        currentRecordId={isCurrentRecord ? currentRecordId : recordIds[0]}
        isCurrentRecord={isCurrentRecord}
        recordIdx={0}
        recordIds={recordIds}
        spaceById={spaceById}
        spaceAllIds={spaceAllIds}
      />
    );
  }
}

const mapState = ({ core, space }: IRootState) => ({
  currentRecordId: core.currentRecordId,
  editingSpaceId: space.editingSpaceId,
  isEditingMode: space.isEditingMode,
  isSpaceLoading: space.isLoading,
  spaceById: space.byId,
  spaceAllIds: space.allIds,
  recordIds: core.viewById[core.currentViewId].recordsAllIds || [],
});

export default connect(mapState)(Print);
